import XAPPService from "app/Core/services/XAPPService";
import React from "react";
export const CONTEUDO_PAINEL_FIXO = "[PAINEL FIXO DIREITA] CONTEUDO PAINEL FIXO";

export function changeContentPainel(conteudo = null) {
    return {
        type: CONTEUDO_PAINEL_FIXO,
        conteudo: conteudo
    };
}

export function getUrlHelp(_APath = "") {
    return (dispatch) => {
        XAPPService.getUrlHelp(_APath)
            .then(response => {
                dispatch(changeContentPainel(
                    <iframe
                        id={"iframe_Help"}
                        src={response}
                        width={"100%"}
                        height={"95%"}
                    ></iframe>
                ));
            })
            .catch(error => {
                console.error(error);
            });
    };
}